import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FooterMenusList from './components/FooterMenusList';
import FooterMenuForm from './components/FooterMenuForm';
import SingleFooterMenu from './single';

const FooterMenusRoutes = () => {
  return (
    <Routes>
      <Route path='' element={<FooterMenusList />} />
      <Route path='create' element={<FooterMenuForm />} />
      <Route path='edit/:id' element={<FooterMenuForm />} />
      <Route path=':id' element={<SingleFooterMenu />} />
      <Route path='*' element={<Navigate to='' replace />} />
    </Routes>
  );
};

export default FooterMenusRoutes;
